var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.showButton)?_c('div',{staticClass:"chat-button",on:{"click":_vm.loadChatBot}}):(_vm.isChatLoading)?_c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"spinner"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }